import { Link, useLocation } from "react-router-dom";
import { Bell, ChevronDown } from "lucide-react";

export default function DashboardNavbar() {
  const location = useLocation();

  const navLinks = [
    { label: "Blogs", path: "/dashboard" },
    { label: "My Blogs", path: "/dashboard/my-blogs" },
    { label: "Drafts", path: "/dashboard/drafts" },
    { label: "Writer Guidelines", path: "/dashboard/writer-guidelines" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="sticky top-0 z-50 w-full bg-white border-b border-slate-100">
      <div className="flex items-center justify-between px-5 md:px-16 py-4 gap-6">
        <Link to="/" className="text-xl font-extrabold flex-shrink-0">
          <span className="text-slate-900">Solo</span>
          <span className="text-[#7209B7]">Connect.</span>
        </Link>

        <div className="hidden md:flex items-center gap-8 text-sm font-medium">
          {navLinks.map((link) => (
            <Link
              key={link.label}
              to={link.path}
              className={`transition-colors duration-200 ${
                isActive(link.path)
                  ? "text-[#7209B7] font-semibold"
                  : "text-slate-600 hover:text-[#7209B7]"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-4 flex-shrink-0">
          <button
            type="button"
            className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-slate-100 transition-colors duration-200"
            aria-label="Notifications"
          >
            <Bell className="w-5 h-5 text-slate-600" />
          </button>

          <div className="flex items-center gap-2">
            <img
              src="/img/blog/avatar-1.svg"
              alt="Harsh Rohilla"
              className="w-9 h-9 rounded-full object-cover bg-slate-200"
            />
            <span className="hidden sm:block text-sm font-medium text-slate-800">
              Harsh Rohilla
            </span>
            <ChevronDown className="w-4 h-4 text-slate-500" />
          </div>
        </div>
      </div>
    </nav>
  );
}
